import React from "react";
const Contact = () => {
  return (
    <div className="animate__animated animate__flip">
      <h1>Contact Us</h1>
      <div className="ratio ratio-21x9">
        <iframe
          className="rounded shadow"
          src="https://www.youtube.com/embed/elP37aYBJE4"
          title="Vpos web app mesin kasir online"
          allowfullscreen
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-3">
          <p>Hubungi Kami untuk informasi dan order</p>
          <p>
            WhatsApp : +62895339403223
            <br />
            Call Us : +62895339403223
            <br />
            Email : axcora@gmail.com
          </p>
        </div>
        <div className="col-12 col-md-6 p-3">
          <p>
            Showroom <br />
            Ruko Pasar Wisata Juanda <br />
            Blok Q.05-07 <br /> Sidoarjo - East Java
            <br />
            Indonesia.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Contact;
